import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import Styles from "../styles.module.scss";
import AuthHead from "../AuthHead";
import AuthMedia from '../authMedia';
import Headline5 from '../../../compopnents/headings/Headline5';
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import { ResetPasswordForm } from './resetform';
import NotificationAlert from '../../../compopnents/notification';
import mixpanelData, { viewedpageMixpanel } from '../../../utils/mixpanel';


Auth.configure({
  userPoolId: "ap-south-1_RFCGvpA7m",
  userPoolWebClientId: "3mbs8c16e6jc3g0l7iq56obak0", // app client id
  //identityPoolId: "42efbd0d-8bcb-46a2-b028-0a8affe3bb63",
  region: "ap-south-1",
  oauth: {
    region: "ap-south-1",
    domain: "https://ellow-prod-customer.auth.ap-south-1.amazoncognito.com",
    scope: ["phone", "email", "openid", "aws.cognito.signin.user.admin", "profile"],
    redirectSignIn: "https://mytalent-ellow.io/dashboard",
    redirectSignOut: "https://mytalent-ellow.io/customerlogin",
    responseType: "code" // or 'token', note that REFRESH token will only be generated when the responseType is code
  }
});

function ResetPassword() {

  let navigate = useNavigate()

  let query: any = window.location.href
  let urlParams:any = new URL(query);
  let userName:any = urlParams.searchParams.get("username")
  let code:any = urlParams.searchParams.get('confirmationCode')
  let email = localStorage.getItem('Email')

  const[password, setPassword] = useState<any>()
  const [error, setError] = useState<string>('')
  const [notification,setNotification] = useState<boolean>(false)

  useEffect(() => {
    
    viewedpageMixpanel()
  
  },[])

  const submitValues = (data: any) => {
      
    Auth.forgotPasswordSubmit(userName, code, data.Newpassword)
      .then(confirmationResult => {
        mixpanelData('MT -Reset Password', {
          'source': "Customer resets his password",
          'success':  true,
          'distinct_id': email,
          'Email': email
        })     
        setPassword(data.Newpassword)
        setNotification(true)
        setTimeout(() => {
        setNotification(false)
        Auth.signIn(userName, data.Newpassword)
          .then(async (result: any) => {  
            localStorage.setItem('loginId',result.username)
            navigate(`/customerlogin`, {
              state: {
                loginId: result.username
              }
             });
          })
          .catch(err => {
            setError(err.message)
          })
       }, 3000)
    })
    .catch(err => {
    setError(err.message)
    })
  }

  const onClose = () =>{
    Auth.signIn(userName, password)
    .then(async (result: any) => {
      localStorage.setItem('loginId',result.username)
      navigate(`/customerlogin`, {
        state: {
          loginId: result.username
        }
      })
    })
    .catch(err => {
      setError(err.message)
    })
  }

  return (
    <section className="App">
      <div className={Styles.authWapper}>
        <div className={Styles.loginForm}>
          <AuthHead />
          <div className={Styles.alignCenter}>
            <aside className={Styles.loginSignupWapper}>
            <Headline5>Reset Your Password ?</Headline5>
            {notification&& <NotificationAlert closable={true} onClose={onClose}>Password updated successfully</NotificationAlert>}
            <div className={Styles.loginWith}>
              <ResetPasswordForm  ClickHandler={submitValues} />
              { error ?  <div><p className="error-message">{error}</p></div> : <div></div> }
              <div className={Styles.alreadyRegistered}>
                Don’t have an ellow account? <Link to=" ">Sign up</Link>
              </div> 
            </div>
            </aside>
          </div>
        </div>
        <AuthMedia/>
      </div>
    </section>
  )
}

export default ResetPassword;
